import {
  Component,
  ChangeDetectionStrategy,
  TemplateRef,
  OnInit,
  Input,
} from '@angular/core';
import {
  startOfDay,
  endOfDay,
  subDays,
  addDays,
  endOfMonth,
  isSameDay,
  isSameMonth,
  subHours,
  addHours,
  endOfWeek,
  startOfWeek,
  addMinutes
} from 'date-fns';
import { Subject } from 'rxjs';
import {
  CalendarEvent,
  CalendarEventAction,
  CalendarEventTimesChangedEvent,
  CalendarView
} from 'angular-calendar';
import { InstructorService } from "src/app/service/instructor.service";
import { ActivatedRoute } from "@angular/router";
import { Lesson } from "src/app/model/lesson.model";
import { ReservationSubItem } from "src/app/model/reservation.model";
import { MatDialog } from "@angular/material";
import { LessonDetailComponent } from "../../lesson/lesson-detail/lesson-detail.component";
import { LessonService } from "src/app/service/lesson.service";
import { DeleteConfirmationDialog } from "../../delete-confirmation/delete-confirmation.dialog";
import { LessonSelectionComponent } from "../../lesson/lesson-selection/lesson-selection.component";
import { TimeSlot } from "src/app/model/time-slot.model";
import { Role } from "src/app/model/role.model";
import { AuthService } from "src/app/service/auth.service";
import { User } from "src/app/model/user.model";
import { Instructor } from "src/app/model/instructor.model";
import { DatePipe } from '@angular/common';

const colors: any = [
  {
    primary: "#c2f0c2",
    secondary: "#ebfaeb"
  },
  {
    primary: "#e6f2ff",
    secondary: "#b3d9ff"
  },
  {
    primary: "#ffb3b3",
    secondary: "#ff8080"
  },
  {
    primary: "#ffe0b3",
    secondary: "#ffcc80"
  },
  {
    primary: "#ffb3b3",
    secondary: "#ffe6e6"
  }
];

@Component({
  selector: "app-schedule-instructor",
  templateUrl: "./schedule-instructor.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ["./schedule-instructor.component.css"]
})
export class ScheduleInstructorComponent implements OnInit {
  @Input() editable = true;
  @Input() reservationItem: ReservationSubItem;
  private _instructorId = -1;
  @Input()
  set instructorId(instructorId: number) {
    this._instructorId = instructorId;
    this.showInstructorLessons(this._instructorId);
  }
  instructor: Instructor;
  emptyEventTtile = "NEW GROUP";
  view: CalendarView = CalendarView.Week;
  weekStartsOn = 1;
  CalendarView = CalendarView;
  refresh: Subject<any> = new Subject();
  viewDate: Date = new Date();

  actions: CalendarEventAction[] = [
    {
      label: '<i class="fa fa-fw fa-pencil"></i>',
      onClick: ({ event }: { event: CalendarEvent<Lesson> }): void => {
        this.handleEvent("Edited", event);
      }
    },
    {
      label: '<i class="fa fa-fw fa-times"></i>',
      onClick: ({ event }: { event: CalendarEvent<Lesson> }): void => {
        this.events = this.events.filter(iEvent => iEvent !== event);
        this.handleEvent("Deleted", event);
      }
    }
  ];

  newEventActions: CalendarEventAction[] = [
    {
      label: "Create",
      onClick: ({ event }: { event: CalendarEvent<Lesson> }): void => {
        this.handleEvent("AddNew", event);
      }
    },
    {
      label: " Delete",
      onClick: ({ event }: { event: CalendarEvent<Lesson> }): void => {
        this.handleEvent("DeleteNew", event);
      }
    }
  ];


  events: CalendarEvent<Lesson>[] = [];

  lessons: Lesson[];
  currentUser: User;

  constructor(
    private instructorService: InstructorService,
    private activatedRoute: ActivatedRoute,
    public dialog: MatDialog,
    private lessonService: LessonService,
    private authService: AuthService,
    private datePipe: DatePipe
  ) {
    this.authService.currentUser.subscribe(x => (this.currentUser = x));
  }

  ngOnInit(): void {
    if (this._instructorId > -1) {
      this.instructorService
        .getById(this._instructorId)
        .subscribe(x => (this.instructor = x));
      this.showInstructorLessons(this._instructorId);
    } else {
      this.activatedRoute.params.subscribe(params => {
        this._instructorId = params.id;
        if (this._instructorId > 0) {
          this.instructorService
          .getById(this._instructorId)
          .subscribe(x => (this.instructor = x));
          this.showInstructorLessons(this._instructorId);
        }
      });
    }
  }

  showInstructorLessons(instructorId: number) {
    this.instructorService
      .getInstructorLessons(instructorId)
      .subscribe(data => {
        this.lessons = data as Lesson[];
        this.reloadEvents();
      });
  }

  reloadEvents() {
    this.events = [];
    for (const lesson of this.lessons) {
      for (const timeslot of lesson.timeSlots) {
        console.log(timeslot.start);
        this.events.push({
          start: subHours(new Date(timeslot.start + '.000Z'), 1),
          end: subHours(new Date(timeslot.end + '.000Z'), 1),
          title: lesson.name,
          color: colors[lesson.lessonType.id],
          meta: lesson,
          id: timeslot.id
        });
      }
    }
    this.refresh.next();
  }

  selectPreviousWeek() {
    this.viewDate = subDays(
      startOfWeek(this.viewDate, { weekStartsOn: this.weekStartsOn }),
      1
    );
  }

  selectNextWeek() {
    this.viewDate = addDays(
      endOfWeek(this.viewDate, { weekStartsOn: this.weekStartsOn }),
      1
    );
  }

  handleEvent(action: string, event: CalendarEvent<Lesson>): void {
    if (!this.isAdmin) {
      return;
    }
    if (action === "AddNew") {
      this.addNew(event);
    } else if (action === "DeleteNew") {
      this.deleteEmptyEventIfExists();
    }
  }

  addNew(event: CalendarEvent<Lesson>) {
    if (!this.isAdmin) {
      return;
    }
    let selectedTimeSlot = new TimeSlot();
    selectedTimeSlot.start = event.start;
    selectedTimeSlot.end = event.end;
    const dialogRef = this.dialog.open(LessonSelectionComponent, {
      width: "70%",
      data: {
        instructorId: this._instructorId,
        timeSlot: selectedTimeSlot
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.showInstructorLessons(this._instructorId);
    });
  }

  deleteEmptyEventIfExists() {
    const emptyEvent = this.events.find(e => e.title === this.emptyEventTtile);
    if (emptyEvent) {
      const index = this.events.indexOf(emptyEvent, 0);
      this.events.splice(index, 1);
    }
    this.refresh.next();
  }

  deleteEvent(event: CalendarEvent<Lesson>) {

    const dialogRef = this.dialog.open(DeleteConfirmationDialog, {
      width: '300px',
      data: {
        title: `DELETE ${event.meta.name}`,
        message: `Time slot \
          ${this.datePipe.transform(event.start, 'dd.MM.yy hh:mm')}-${this.datePipe.transform(event.end, 'dd.MM.yy hh:mm')}
          Enter lesson name to confirm delete`,
        key: event.meta.name,
        enterKeyToConfirm: true
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.lessonService.deleteTimeSlot(event.meta.id, event.id as number).subscribe(data => {
          this.showInstructorLessons(this._instructorId);
        });
      }
    });
  }

  hourClicked($event) {
    if (!this.isAdmin) {
      return;
    }
    if (this.editable) {
      const dialogRef = this.dialog.open(DeleteConfirmationDialog, {
        width: "300px",
        data: {
          title: "Add new period",
          message: "Are you sure you want to add new period",
          key: "",
          enterKeyToConfirm: false
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.createEmptyEvent($event);
        }
      });
    }
  }

  createEmptyEvent($event) {
    if (!this.isAdmin) {
      return;
    }
    this.deleteEmptyEventIfExists();
    this.events.push({
      start: $event.date,
      end: addMinutes($event.date, 60),
      title: this.emptyEventTtile,
      color: colors[4],
      actions: this.newEventActions,
      resizable: {
        beforeStart: true,
        afterEnd: true
      },
      draggable: true
    });
    this.refresh.next();
  }

  eventClicked($event) {
    console.log($event);
    if (!this.isAdmin) {
      return;
    }
    if (this.editable && $event.event.meta) {
      this.editLesson($event.event.meta);
    }
  }

  editLesson(lesson: Lesson) {
    if (!this.isAdmin) {
      return;
    }
    const dialogRef = this.dialog.open(LessonDetailComponent, {
      width: "70%",
      height:"80%",
      data: {
        selectedLesson: lesson,
        selectedReservationItem: this.reservationItem
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.reservationItem = result;
    });
  }

  eventTimesChanged({
    event,
    newStart,
    newEnd
  }: CalendarEventTimesChangedEvent): void {
    if (!this.isAdmin) {
      return;
    }
    this.events = this.events.map(iEvent => {
      if (iEvent === event) {
        return {
          ...event,
          start: newStart,
          end: newEnd
        };
      }
      return iEvent;
    });
    this.handleEvent("Dropped or resized", event);
  }

  get isAdmin() {
    return this.currentUser && this.currentUser.role === Role.Admin;
  }
}
